<template>
  <div class="about">
    <p>A site for trackers to better the world.</p>
  </div>
</template>
